module.exports = __webpack_public_path__ + "media/images/no_content.icon.jobs-9f6d0f35.png";